import { createContext, useContext } from 'react';

type ValidationContextType = {
    // Validation context (currently empty, kept for backward compatibility)
};

const ValidationContext = createContext<ValidationContextType | null>(null);

export const ValidationProvider: React.FC<{ children: React.ReactNode }> = ({
    children
}) => {
    return (
        <ValidationContext.Provider value={{}}>
            {children}
        </ValidationContext.Provider>
    );
};

export const useValidation = () => {
    const ctx = useContext(ValidationContext);
    if (!ctx) {
        // Return empty object if context is not available (for components outside the provider)
        return {};
    }
    return ctx;
};
